const Report = () => import(/* webpackChunkName: "report" */ '@/views/report/report-main.vue');
const Chart = () => import(/* webpackChunkName: "chart" */ '@/views/report/chart-main.vue');
const ReportDesignMain = () =>
    import(
        /* webpackChunkName: "report-design-main" */ '@/views/back-stage/report-design/report-design-main.vue'
    );
const ReportDesign = () =>
    import(
        /* webpackChunkName: "report-design" */ '@/views/back-stage/report-design/report-design.vue'
    );

const ReportRootRoute = [
    {
        path: '/report/:reportCode',
        name: 'report',
        component: Report,
    },
    {
        path: '/chart/:reportCode/:chartCode',
        name: 'chart',
        component: Chart,
    },
];

const ReportBackStageRoute = {
    path: '/reportdesign/:reportCode',
    component: ReportDesignMain,
    children: [
        {
            path: '',
            name: 'report-design',
            component: ReportDesign,
        },
    ],
};

export { ReportRootRoute, ReportBackStageRoute };
